import React from "react";
import autobind from "class-autobind";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { InputBox } from "../../form/input.box/index";
import { Button } from "../../button/index";
import { FaBars, FaMinusCircle } from "react-icons/fa";
import {Tooltip} from "../../tooltip/index";
import {Checkbox} from "../../form/checkbox";
import {arrayMove, SortableContainer, SortableElement, SortableHandle} from "react-sortable-hoc";

interface ComponentProps {
  values: DeliveryZone[];
  onChange: (values: DeliveryZone[]) => void;
}

type ItemType = DeliveryZone;
type ListType = ItemType[];
type HandleChange = (i: number, key: keyof Omit<ItemType, "polygon">, value: any) => void;
type HandleRemove = (i: number) => void;
type HandleSort = (data: { oldIndex: number; newIndex: number }) => void;

interface ListProps {
  items: ListType;
  change: HandleChange;
  remove: HandleRemove;
}
interface ItemProps {
  item: ItemType;
  itemIndex: number;
  itemsLength: number;
  change: HandleChange;
  remove: HandleRemove;
}

const DragHandle = SortableHandle(() => {
  return (
    <InputBox className="no-round width40 min40 flex-center cursor-move">
      <p className="big font-bold">
        <FaBars/>
      </p>
    </InputBox>
  );
});

const SortableItem = SortableElement((props: ItemProps) => {
  const { itemIndex, change, remove, item } = props;
  return (
    <div key={itemIndex} className="flex-line" style={{ alignItems: "flex-end" }}>

      <DragHandle/>

      <InputBox className="no-round width64 min64 text-center">
        <p className="big font-bold" style={{ lineHeight: "36px" }}>{itemIndex + 1}</p>
      </InputBox>

      <div className="flex-line" style={{ alignItems: "flex-end" }}>
        <FormGroup
          className="m-b-0"
          no_border={true}>
          <Input
            type="text"
            className="no-round"
            style={{ width: "220px" }}
            value={item.name}
            onChange={(e) => change(itemIndex, "name", e.target.value)}/>
        </FormGroup>
        <FormGroup
          className="m-b-0"
          no_border={true}>
          <Input
            type="number"
            min={0}
            step={0.01}
            className="no-round"
            style={{ width: "100px" }}
            value={item.fee || ""}
            onChange={(e) => change(itemIndex, "fee", e.target.value)}/>
        </FormGroup>
        <FormGroup
          className="m-b-0"
          no_border={true}>
          <InputBox className="no-round flex-center width75">
            <Checkbox
              id={`${itemIndex}-disabled-fee`}
              checked={item.disabled || false}
              onChange={(e) => change(itemIndex, "disabled", e.target.checked)}/>
          </InputBox>
        </FormGroup>
      </div>

      <Tooltip text="Delete" width={65} position="top">
        <Button type="button" className="no-round" paddinglr={5} color="white" onClick={() => remove(itemIndex)}>
          <FaMinusCircle/>
        </Button>
      </Tooltip>

    </div>
  );
});

const SortableItemContainer = SortableContainer((props: ListProps) => {
  return (
    <div>
      {props.items.map((item, i) => (
        <SortableItem
          key={`item-${i}`}
          index={i}
          item={item}
          itemIndex={i}
          itemsLength={props.items.length}
          change={props.change}
          remove={props.remove}
        />
      ))}
    </div>
  );
});

export class FieldDeliveryZones extends React.Component<ComponentProps> {

  constructor(props: ComponentProps) {
    super(props);
    autobind(this);
  }

  remove(i: number) {
    const values = ([ ...this.props.values ]);
    values.splice(i, 1);
    this.props.onChange(values);
  }

  change: HandleChange = (i, key, value) => {
    const values = [ ...this.props.values ];
    values[i][key] = value;
    this.props.onChange(values);
  }

  onSortEnd: HandleSort = ({oldIndex, newIndex}) => {
    const { onChange, values } = this.props;
    onChange(arrayMove(values, oldIndex, newIndex));
  }

  render() {
    const { values } = this.props;
    return (
      <div>

        <div className="flex-line" style={{ alignItems: "flex-end" }}>

          <div style={{width: "104px", minWidth: "104px"}}/>

          <div className="flex-line" style={{ alignItems: "flex-end" }}>

            <FormGroup
              style={{ width: "220px" }}
              className="m-b-0"
              title={"Zone Name"}
              small_title={true}
              no_border={true}/>

            <FormGroup
              style={{ width: "100px" }}
              className="m-b-0"
              title={"Cost ($)"}
              small_title={true}
              no_border={true}/>

            <FormGroup
              style={{ width: "75px" }}
              className="m-b-0"
              title={"Disabled"}
              small_title={true}
              no_border={true}/>

          </div>

        </div>

        <SortableItemContainer
          helperClass="zindex-100 bsl-2"
          pressDelay={50}
          useDragHandle={true}
          items={values}
          change={this.change}
          remove={this.remove}
          onSortEnd={this.onSortEnd}
        />

      </div>
    );
  }

}
